import React from 'react';
import { useScrollTrigger } from '@material-ui/core';

const ElevationScroll = ({ children, forceElevate }) => {
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0,
  });

  return React.cloneElement(children, {
    elevation: forceElevate || trigger ? 4 : 0,
  });
};

export default ElevationScroll;
